import { actions } from 'react-table';
import { REQUEST_FETCH_DRAFTS_ERROR, REQUEST_FETCH_DRAFTS_SUCCESS, REQUEST_FETCH_DRAFTS_START } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], isLoading: true };

export default function calendarData(state = INITIAL_STATE, action) {

  switch (action.type) {
    case REQUEST_FETCH_DRAFTS_SUCCESS:
      return { ...state, isLoading: false, data: action.payload?.data?.data || [] }
    case REQUEST_FETCH_DRAFTS_ERROR:
      return { ...state, isLoading: false, data: [] }
    case REQUEST_FETCH_DRAFTS_START:
      return { ...state, isLoading: true, data: [] }
    default:
      return state;
  }
}